<div class="uk-offcanvas-content" style="min-height:100vh; display:flex; flex-direction:column;">
  <app-external-header uk-sticky [style.z-index]="hideAppShell() ? -1 : 9999"></app-external-header>
  @if (!hideAppShell()) {
    <div>
      <app-top-menu-eosc style="z-index: -1"></app-top-menu-eosc>
    </div>
    <div style="margin-top: 159px;"></div>
  }

  <div style="flex:1;">
    @if (((router.url !== '/becomeAProvider' && router.url !== '/home' && router.url !== '/' && !isDashboardRoute())) && !hideAppShell()) {
      <app-breadcrumbs ></app-breadcrumbs>
    }
    <router-outlet></router-outlet>
  </div>

  <div class="helpdesk-overlay uk-animation-scale-up">
    <button class="uk-button helpdesk-overlay-button" [routerLink]="['/helpdesk/create']" type="button">
      <span class="helpdesk-span">
        <i class="material-symbols-outlined" style="font-size: 24px;">help</i>
        <span class="helpdesk-label">Helpdesk</span>
      </span>
    </button>
  </div>

  @if (!hideAppShell()) {
    @if (!isDashboardRoute()) {
      <app-external-footer></app-external-footer>
    } @else {
      <div style="margin-left: 260px">
        <app-external-footer></app-external-footer>
      </div>
    }
    <cookie-law position="bottom">
      EOSC uses cookies in order to function properly.<br>
      Cookies are small pieces of data that websites store in your browser to allow us to give you the best browsing experience possible.
      By using the EOSC portal you accept our use of cookies. <a href="http://ec.europa.eu/ipg/basics/legal/cookies/index_en.htm" target="_blank" style="color: #6a9eeb"> Read more<span class="uk-icon">
      <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" icon="chevron-right" ratio="1"><polyline fill="none" stroke="#000" stroke-width="1.03" points="7 4 13 10 7 16"></polyline></svg>
      </span></a>
    </cookie-law>
  }
</div>
